import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const brl = (n) =>
  (Number(n) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const STATUS_LABEL = {
  draft: "Rascunho",
  sent: "Enviado",
  viewed: "Visualizado",
  approved: "Aprovado",
  rejected: "Recusado",
  expired: "Vencido",
};

export const STATUS_COLOR = {
  draft: "#71717A",
  sent: "#3B82F6",
  viewed: "#8B5CF6",
  approved: "#10B981",
  rejected: "#EF4444",
  expired: "#F59E0B",
};
